import { commandHandlerService } from "./commandHandlerService";

export function initializeEventHandlerService() {
    window.addEventListener('message', (event) => {
        if (commandHandlerService.hasHandler(event.data.action)) {
            commandHandlerService.handleCommand(event.data.action, event.data, event, (callbackData) => {
                if (!callbackData) {
                    callbackData = {};
                }

                if (event.data.responseCommand) {
                    callbackData.action = event.data.responseCommand;
                }
                if (event.source) {
                    event.source.postMessage(callbackData, event.origin);
                }
            });
        }
    }, false);
}


// WEBPACK FOOTER //
// ./src/services/eventHandlerService.js